<!--
 * @Author: zhengxiaoxiao
 * @Date: 2020-08-17 16:47:40
 * @Description: 
-->

<template>
    <div>
        <KHeader :scrollFlag="true"></KHeader>
        <MediaForm></MediaForm>
        <KFooter></KFooter>
    </div>
</template>
<script>
import KHeader from '../../components/kllk-header-nav'
import KFooter from '../../components/kllk-footer-nav'
import MediaForm from './media-form'
export default {
    components: {
        KHeader, KFooter, MediaForm
    },
    data() {
        return {
            
        }
    }
}
</script>